export default Object.freeze({
  retryCharge: 'retry_charge',
  markAsPaid: 'mark_as_paid',
  markUncollectible: 'uncollectible',
  modifyPaymentMethod: 'change_payment_method',
  changeDueDate: 'change_due_date',
  refund: 'refund',
  setupPaymentInfo: 'setup_payment_info',
});
